// extracted by mini-css-extract-plugin
export default {"popover":"Popover-module__popover","fade-in":"Popover-module__fade-in","hidden":"Popover-module__hidden"};